var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("BaseModal", {
    attrs: {
      "is-open": _vm.isOpen,
      "is-loading": _vm.isStatusLoading,
      identifier: "register-payment-flow-modal",
      "keep-alive-views": "RegisterPlanSelectConversionMinutesView",
      "transition-name": _vm.transitionName,
    },
    on: { "modal-close": _vm.closeModal },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }